/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Forward_Three_SecondsInputs */



/**
* | output |
* | --- |
* | "Forward 3 Second" |
*
* @param {Shortcut_Keys_Name_Forward_Three_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_forward_three_seconds = /** @type {((inputs?: Shortcut_Keys_Name_Forward_Three_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Forward_Three_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avancer de 3 secondes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorwärts 3 Sekunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avanti di 3 secondi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вперед, 3 секунды")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avanzar 3 segundos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前进 3 秒")
	if (locale === "ja") return /** @type {LocalizedString} */ ("3秒進む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आगे 3 सेकंड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Avançar 3 segundos")
	return /** @type {LocalizedString} */ ("Forward 3 Second")
});